export default {
  banks: [],
  bankMaxCode: null,

  bankBranches: [],
  branchMaxCode: null,

  bankCashAccountInfo: [],
  bankCashAccountId: null,
  bankCashAccountInfoById: {},
  bankCashAccountInfoVoucher: [],
  bankCashAccountInfoCode: null,
  chequeStatuses: [],

  chequeBatch: [],
  chequeBatchCode: null,

  chequeBatchDetail: [],

  receiveCashes: [],
  receiveCash: {},
  receiveCashCode: null,
  receiveCashNavigation: {},
  receiveCashCheckDelete: "",
  receiveCashVoucher: [],

  paymentCashes: [],
  paymentCash: {},
  paymentCashCode: null,
  paymentCashNavigation: {},
  paymentCashCheckDelete: "",
  requestPayments: [],
  requestPayment: {},
  requestPaymentCode: null,
  requestPaymentNavigation: {},

  receiveCheques: [],
  receiveCheque: {},
  receiveChequeCode: null,
  receiveChequeBackNumber: null,
  receiveChequeBankTransfer: null,
  receiveChequeSampleExcel: null,
  receiveChequeCartable: [],
  receiveChequeVoucher: [],
  receiveChequeNavigation: {},

  transactionInfo: [],

  voucherTemplate: [],
  bankTransfers: [],

  assignmentPersons: [],

  settlements: [],

  returnTransferreds: [],

  cancellationReceivables: [],

  returnReceivables: [],

  returnGuarantees: [],

  returnAssignments: [],

  requestPaymentConfirm: [],

  receiveChequeTurns: [],
  receiveChequeTurn: {},

  paymentCheques: [],
  paymentCheque: {},
  paymentChequeCode: null,
  paymentChequeNavigation: {},
  paymentChequeCartable: [],
  paymentChequeSampleExcel: null,
  paymentChequeCheckDelete: "",
  paymentChequeVoucher: [],

  paymentChequeTurns: [],
  paymentChequeTurn: {},

  passPayDocs: [],

  cancelPayableDocs: [],

  returnGuaranteeDocs: [],

  receiveChequeReport: [],
  receiveCashAndCahPaymentReport: [],
  monthlyComparisonReceiveAndPaymentCashReport: [],
  historyReceiveChequeReport: [],
  dueReceiveChequeReport: [],
  monthlyComparisonReceiveChequeReport: [],
  summaryReceiveChequeReport: [],

  paymentChequeReport: [],
  historyPaymentChequeReport: [],
  monthlyComparisonPaymentChequeReport: [],
  paymentChequeToPersonReport: [],
  paymentChequeToAccountInfoReport: [],
  paymentChequeTurnReport: [],
  summaryPaymentChequeReport: [],
  overduePaymentChequeReport: [],

  circulationVoucherReport: [],

  accountInventoryReport: [],
  summaryPaymentChequeTab: [],
  summaryReceiveChequeTab: [],
  summaryReceiveAndPaymentCash: [],

  accountConfig: [],

  accountInfo: [],
  accountInfoCode: null,

  lastAccount: [],

  voucherNoteType: [],

  defaultVoucherDescription: [],

  financialRatio: [],
  financialRatioItem: {},

  numerator: [],
  denominator: [],

  voucherCheckCreate: {},
  voucherCheckUpdate: {},

  vouchers: [],
  vouchersTotalCount: 0,
  voucher: {},
  voucherNavigation: {},
  voucherId: null,
  lastVoucherInfo: {},

  voucherAttaches: [],

  personCredits: [],

  userLimitAccounts: [],

  voucherNotes: [],

  confirmCartable: [],
  unConfirmCartable: [],

  voucherReview: [],

  emptyVoucher: [],

  archiveVoucher: [],
  debtorOrCreditorDeclarations: [],
  debtorOrCreditorDeclaration: {},
  debtorOrCreditorDeclarationCode: null,
  debtorOrCreditorDeclarationNavigation: {},
  debtorOrCreditorDeclarationCheckDelete: "",

};
